export default "__VITE_ASSET__DJiL994G__"